/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file EducationalMaterialView.jsx
 * @author Daniel Aguirre
 * @description Education Material View Page
 */

// Dependencies
import PreviewDocuments from 'components/PreviewDocuments';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router';

/**
 * EducationalMaterial View
 * @param { Object } educationalMaterialActions - EducationalMaterial Actions.
 * @return { Node } React node.
 */

function EducationalMaterialView({ s3FileActions, actions }) {
  const location = useLocation();
  const { id } = useParams();
  const [uriFile, setUriFile] = React.useState(null);

  const { getS3FileByKey } = s3FileActions;
  const { setLoading } = actions;

  const onGetData = (_, resp) => {
    setLoading(false);
    if (resp?.data) setUriFile(resp?.data);
    else setUriFile('../../../assets/dummy-image.jpg');
  };

  React.useEffect(async () => {
    if (id) {
      getS3FileByKey({ key: id }, onGetData);
    }
  }, [id]);

  return (
    <div className="h-full p-3 overflow-scroll text-baxterGray">
      <h1 className="mb-3" style={{ fontSize: 22 }}>
        {location?.state?.name}
      </h1>
      <p className="mt-4" style={{ fontSize: 16 }}>
        {location?.state?.description}
      </p>
      {uriFile && (
        <PreviewDocuments
          url={uriFile}
          fileName={id}
          fileType={location?.state?.type}
        />
      )}
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
EducationalMaterialView.propTypes = {
  educationalElementActions: PropTypes.shape({
    getEducationalElementById: PropTypes.func.isRequired
  }),
  s3FileActions: PropTypes.shape({
    getS3FileByKey: PropTypes.func.isRequired
  }).isRequired,
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired
};

export default EducationalMaterialView;
